<template>
  <div class="statsgtoscoretrend stgsrend">
    <div class="text_normal weight_600 stgsrend_title gw_hvr f-center">
      {{ $t('gto_score_trend.title') }}

      <div
        class="mdi gw_hvr_content mdi-help-circle-outline text-small my-auto ml-1 mr-auto csst"
        style="color: var(--clr-grey-2); --hvr-content-opacity: 0.5"
        @mouseenter="
          e => {
            fl_positionTooltip(e, { offset: 0, placement: 'top' })
          }
        "
      >
        <div
          class="csst_content csst_content_hoverable clr-white"
          style="position: fixed; max-width: clamp(12rem, 26rem, 96vw)"
          v-html="$t('gto_score_trend.title_tooltip')"
        ></div>
      </div>
    </div>

    <div
      class="stgsrend_content-wrapper"
      :class="{
        'stgsrend_content-wrapper_no-data': !items || notEnoughtHandsPlayed,
      }"
      @mouseenter="e => toggleTooltip(true, e)"
      @touchstart="e => toggleTooltip(true, e)"
      @mouseleave="toggleTooltip(false)"
      @touchend="toggleTooltip(false)"
    >
      <ChartAxes
        v-if="!notEnoughtHandsPlayed"
        class="chart_axis-y"
        :hasX="false"
        :YTicks="YTicks"
        style="
          --first-tick-opacity: 1;
          left: 1rem;
          --axis-y-height: calc(100% - 1rem);
          --axis-y-inset: auto auto 1rem 0;
        "
      />
      <ChartAxes
        v-if="!notEnoughtHandsPlayed"
        class="chart_axis-x"
        :hasY="false"
        :XTicks="XTicks"
        style="
          --first-tick-opacity: 1;
          left: 1rem;
          --axis-x-width: calc(100% - 1rem);
          --axis-x-inset: auto auto 0 1rem;
        "
      />
      <div
        ref="chart"
        class="stgsrend_content"
        @mousemove="handleMousemove"
        @touchmove="handleMousemove"
      >
        <div
          v-if="conf.hasZeroY"
          class="stgsrend_axis-zero"
          :style="`bottom: ${conf.axisZeroY * 100}%`"
        >
          <div class="stgsrend_axis-zero_content">0</div>
        </div>
        <div
          v-if="notEnoughtHandsPlayed"
          class="gw_box clr-grey weight_500"
          style="position: absolute"
        >
          <router-link :to="{ name: 'PracticeTrainer' }">
            <span class="text-underline_hover cursor-pointer clr-primary">
              {{ $t('gto_score_trend.under_100_hands_prompt') }}
            </span>
          </router-link>
        </div>
        <!-- :style="styleAxes" -->
        <svg
          v-if="!notEnoughtHandsPlayed"
          class="trendchart_svg"
          viewBox="0 0 1 1"
          preserveAspectRatio="none"
          :style="`height:${conf.percentScale * 100}%; top: ${conf.svgTopPercentage * 100}%;`"
        >
          <!-- base 0 to 100 for [0.599, 0.599, 0.599, 0.699, 0.699, 0.699, 0.8499, 0.8499, 0.8499, 0.8499, 0.8499]  -->
          <!-- <defs>
            <linearGradient id="lgrad" x1="50%" y1="0%" x2="50%" y2="100%">
              <stop offset="0%" :style="`stop-color: var(--clr-primary)`" />
              <stop offset="30%" :style="`stop-color: var(--clr-primary)`" />
              <stop offset="30%" :style="`stop-color: var(--clr-yellow)`" />
              <stop offset="75%" :style="`stop-color: var(--clr-yellow)`" />
              <stop offset="75%" :style="`stop-color: var(--clr-error)`" />
              <stop offset="100%" :style="`stop-color: var(--clr-error)`" />
            </linearGradient>
          </defs> -->

          <defs>
            <linearGradient
              id="lgrad"
              x1="50%"
              y1="0%"
              x2="50%"
              y2="100%"
            >
              <stop
                v-if="conf.point_primary"
                :offset="`0%`"
                :style="`stop-color: var(--clr-primary)`"
              />
              <stop
                v-if="conf.point_primary"
                :offset="`${conf.point_primary.grad * 100}%`"
                :style="`stop-color: var(--clr-primary)`"
              />
              <stop
                v-if="conf.point_primary"
                :offset="`${conf.point_primary.grad * 100}%`"
                :style="`stop-color: var(--clr-yellow)`"
              />
              <stop
                v-if="conf.point_yellow"
                :offset="`${conf.point_yellow.grad * 100}%`"
                :style="`stop-color: var(--clr-yellow)`"
              />
              <stop
                v-if="conf.point_yellow"
                :offset="`${conf.point_yellow.grad * 100}%`"
                :style="`stop-color: var(--clr-error)`"
              />
              <stop
                v-if="conf.point_error"
                :offset="`100%`"
                :style="`stop-color: var(--clr-error)`"
              />
            </linearGradient>
          </defs>
          <g
            class="trendchart_svg_content"
            stroke="url(#lgrad)"
          >
            <!-- <g class="trendchart_svg_content" stroke="var(--clr-primary)"> -->
            <!-- <g class="trendchart_svg_content" stroke="var(--clr-black-0)"> -->
            <SvgPath
              style="z-index: 0; position: relative"
              :pointsXY="pointsXY"
              class="trendchart_path"
              vector-effect="non-scaling-stroke"
            />
          </g>
          <!-- <g class="trendchart_svg_content"> -->
          <path
            v-for="(hp, idx) in pointsXY"
            :key="`${hp.id}_${idx}`"
            :data-id="hp.id"
            :style="`--clr-score:${hp.scoreGroup.clr}`"
            :class="{
              trendchart_svg_circle_active: tooltipItem ? tooltipItem.id === hp.id : false,
            }"
            :d="`M ${hp.x} ${hp.y} l 0.0001 0`"
            vector-effect="non-scaling-stroke"
            style=""
            class="trendchart_svg_circle"
          />
          <!-- </g> -->
        </svg>
        <div
          v-if="!notEnoughtHandsPlayed && showTooltip"
          v-show="tooltipItem"
          class="chart_floating-content anim-fade-in no-events"
        >
          <div
            ref="tooltip"
            class="gw_box csst_follow-content text-medium clr-white"
            style="position: absolute; z-index: 6; transition: 0.12s"
          >
            <table
              v-if="tooltipItem"
              class="weight_600 text-nowrap"
            >
              <tr>
                <td>{{ $t('common.hands') }}</td>
                <td class="pl-2 text-right">{{ tooltipItem.hands }}</td>
              </tr>
              <tr>
                <td>{{ $t('common.gto_score') }}</td>
                <td class="pl-2">
                  <div class="f-center">
                    <div
                      class="mdi mr-1 text-normal-large"
                      :class="tooltipItem.scoreGroup.icon"
                      :style="`color: ${tooltipItem.scoreGroup.clr}`"
                    ></div>
                    {{ numFixed(tooltipItem.score * 100) }}%
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          v-if="!notEnoughtHandsPlayed"
          v-show="showTooltip && tooltipItem"
          ref="tooltip_line"
          class="chart_tooltip-line chart_tooltip-line_vertical"
          style="bottom: 0; position: absolute; transition: 0.12s"
        >
          <!-- <div class="chart_tooltip-line_tick">{{ tickPercentageX }}</div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getTrainerScoreGroup } from '@/helpers/trainer'
import { getEveqeqrblColorList } from '@/helpers/colors'
import { getScaledValue } from '@/helpers/helpers'
import { nextTick } from 'vue'

import SvgPath from '@/components/Charts/LineChart/SvgPath'
import ChartAxes from '@/components/Charts/LineCharts/ChartAxes'
import throttle from 'lodash/throttle'

import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'PracticeStatsScoreTrendChart',
  mixins: [format_mix, float_mix],
  props: {
    items: Array,
    loading: Boolean,
  },
  data() {
    return {
      showTooltip: false,
      tooltipItem: null,
      // tickPercentageY: 0,
      // tickPercentageX: 0,
    }
  },
  methods: {
    toggleTooltip(bool, e) {
      if (bool) {
        nextTick(() => {
          this.showTooltip = true
          if (e) {
            nextTick(() => {
              this.handleMousemove(e)
            })
          }
        })
        return
      }
      this.showTooltip = false
      this.tooltipItem = null
      // this.showTooltip = true
    },
    handleMousemove(e) {
      // console.log(e)
      if (this.skeleton) return
      if (!this.showTooltip) return
      const boundary = e.currentTarget // event.currentTarget is only available while the event is being handled
      // const boundary = this.$refs.cont
      if (!boundary) return
      this.setupTooltip(e, boundary)
    },
    setupTooltip: throttle(function (e, boundary) {
      requestAnimationFrame(() => {
        // const customEl = this.$refs.tooltip.$el
        const { tooltip, tooltip_line } = this.$refs
        // console.log(tooltip, tooltip_line)
        if (!tooltip || !tooltip_line) return
        e.preventDefault()
        this.fl_followMouse(e, boundary, tooltip, {
          offsetX: 8,
          offsetY: this.mobile ? -24 : 8,
          padding: 8,
          strategy: 'absolute',
          placement: 'top-start',
        })
        this.fl_followMouse(e, boundary, tooltip_line, {
          offsetX: 0,
          offsetY: 0,
          padding: 0,
          strategy: 'absolute',
        })

        const { percentX } = this.getHoveredPPP(e)
        const idxPercent = (this.pointsXY.length - 1) * percentX
        const idx = this.numFixed(idxPercent)
        this.tooltipItem = this.conf.points[idx]
        // console.log(this.tooltipItem, idx, this.pointsXY, percentX, idxPercent)
      })
    }, 44),
    getHoveredPPP(e) {
      const chart = this.$refs.chart.getBoundingClientRect()
      if (e?.touches) {
        e = {
          clientX: e?.touches[0]?.clientX,
          clientY: e?.touches[0]?.clientY,
        }
      }
      const { clientX, clientY } = e
      const pixelY = clientY - chart.y
      const pixelX = clientX - chart.x
      const percentX = pixelX / chart.width
      const percentY = 1 - pixelY / chart.height
      return {
        percentX,
        percentY,
        pixelY,
        pixelX,
        clientY,
        clientX,
      }
    },
  },
  computed: {
    mobile() {
      return this.$store.getters.globals_mobile
    },
    conf() {
      const items = this.items || null

      // items = [1, 0.88, 1, 1, 1, 0.77, 1, 0.9, 1, 1] // does not work
      // items = [-1, 1, 1, 1, 1, 1, 1, 1, 1, -1]
      // items = [0.5, 1, 1, 1, 1, 1, 1, 1, 1, 1]
      // items = [-0.5, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1]
      // items = [-0.5, 0, 0.8, 0.8, 0.5, 0.75, 0.44, 0.66, 0.88, 0.7, 0.7, -0.25]
      // items = [0.125, 0.8, 0.8, 0.5, 0.75, 0.44, 0.66, 0.88, 0.7, 0.7, 0.25]
      // items = [-0.1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -0.25]
      // items = [0.5, 1, 0.5, 1, 0.5, 1, 0.75, 1, 1, 1, 1]
      // items = [-0.1, -0.3, -0.4, -0.5, -0.6, -0.7, -0.9, -0.9, -0.8, -0.4]

      // let tt = 1000
      // let tt = 100000
      // let itemsPlus = [...Array(tt).keys()].map(i => Math.floor(Math.random() * 1000) / 1000)
      // itemsPlus = itemsPlus.filter(i => i > 0.5)
      // itemsPlus = itemsPlus.filter(i => i > 0.5)
      // itemsPlus = itemsPlus.filter(i => i > 0.5)
      // let itemsMinus = [...Array(tt).keys()].map(i => Math.floor(Math.random() * 1000) / -1000)
      // items = itemsPlus.map((i, idx) => (idx % 2 ? i : itemsMinus[idx]))
      // items = itemsPlus.slice(0, 100)
      // items = itemsPlus
      // items = itemsMinus

      // items = [0.5, 0.55, 0.599, 0.6, 0.65, 0.699, 0.8499, 0.92, 0.93, 0.94]
      // console.log(items)

      // items[0] = 1
      // items[0] = 0.75
      // items[0] = 0.5
      // items[0] = 0.25
      // items[0] = 0
      // items[0] = -0.125
      // items[0] = -0.25
      // items[0] = -0.5
      // items[0] = -0.75
      // items[0] = -1

      const ll = items ? items?.length - 1 : 1
      const max = Math.max(...(items || []))
      const min = Math.min(...(items || []))

      const start = min

      const points = (items || []).map((i, idx) => {
        // i = idx === 99 ? 1 : i
        // i = idx === 0 ? -0.5 : i
        // i = idx === 0 ? -1 : i
        const clrIdx = this.numFixed(Math.floor((i + 1) * 10))
        const yScaled = getScaledValue({ min, max, value: i })
        return {
          id: idx,
          // y: 1 - ((i + 1) / 2), // values range from -1 to 1
          grad: 1 - yScaled, // values range from -1 to 1
          y: 1 - yScaled,
          x: idx / ll,
          val: i,
          score: i,
          clrIdx,
          clr: this.clrList[clrIdx],
          hands: (idx + 1) * 10,
          scoreGroup: getTrainerScoreGroup(i),
        }
      })
      // let hasZeroY = start !== 0
      const hasZeroY = start < -0.125 // so its readable Zero needs about 8px

      let clrPoints = points.map(i => ({ ...i, scoreGroup: i.scoreGroup }))
      clrPoints = clrPoints.sort((a, b) => (a.grad < b.grad ? 1 : -1))
      const point_primary = clrPoints.find(i => i.scoreGroup.clr === 'var(--clr-primary)')
      const point_yellow = clrPoints.find(i => i.scoreGroup.clr === 'var(--clr-yellow)')
      const point_error = clrPoints.find(i => i.scoreGroup.clr === 'var(--clr-error)')

      const svgHeightPercentage = min > 0 ? 1 : start === 0 ? 2 : min > 0 ? 1 : 2 / (1 - start)

      const percentScale = getScaledValue({ min, max: 1, value: max })

      const res = {
        points,
        start,
        min,
        hasZeroY,
        axisZeroY: hasZeroY ? 1 - svgHeightPercentage * 0.5 : 0.5,
        percentScale,
        svgTopPercentage: 1 - percentScale,
        point_primary,
        point_yellow,
        point_error,
      }
      // console.log(res)
      return res
    },
    pointsXY() {
      return this.conf.points
    },
    notEnoughtHandsPlayed() {
      // return !this.items || this.items?.length < 100000
      return !this.pointsXY || this.pointsXY?.length < 10
    },
    scores() {
      return this.pointsXY.map(i => i.score)
    },
    bestPoint() {
      const best = Math.max(...this.scores)
      const res = this.pointsXY.find(i => i.score === best)
      // console.log('bestPoint', res)
      return res || { clr: 'var(--clr-primary)' }
    },

    // middlePoint() {
    //   let sorted = (this.scores || []).map(i => i)
    //   sorted = sorted.sort((a, b) => (a > b ? 1 : -1))
    //   let middleScore = sorted[this.numFixed((sorted.length - 1) / 2)]
    //   let res = this.pointsXY.find(i => i.score === middleScore)
    //   console.log('middlePoint', res, middleScore)
    //   return res || { clr: 'var(--clr-primary)' }
    // },
    // worstPoint() {
    //   let worst = Math.min(...this.scores)
    //   let res = this.pointsXY.find(i => i.score === worst) // console.log('worstPoint', res)
    //   // console.log('worstPoint', res)
    //   return res || { clr: 'var(--clr-primary)' }
    // },
    clrList() {
      const clrList = getEveqeqrblColorList({
        clr1: '#f55353', // red
        clr2: '#00ac8d', // primary
        // clr2: '#ffb800', // yellow
      })
      // return 21 but we use just first 10
      // console.log(clrList)
      return clrList
    },
    YTicks() {
      // let diff = this.worstPoint.score - this.bestPoint.score

      // let middle = this.bestPoint.score + (diff / 2)

      const {start} = this.conf
      // let hasZero = this.conf.start !== 0
      // console.log(diff)
      const res = [
        this.numFixed(start * 100),
        // ...hasZero ? [0] : [null],
        // this.numFixed((middle || 0) * 100),
        // this.numFixed((this.bestPoint.score || 0) * 100),
        100,
      ].filter(i => i !== null)

      // let res = [
      //   -100,
      //   0,
      //   100,
      // ]
      return res
      // return [-100, -50, 0, 50, 100]
    },
    XTicks() {
      let res = this.pointsXY.map(i => i.hands)
      const step = Math.floor((res.length - 1) / 2)
      res = [res[0], res[step], res[res.length - 1]].filter(i => i)
      return res
    },
  },
  components: {
    SvgPath,
    ChartAxes,
  },
}
</script>

<style lang="scss" scoped>
svg {
  display: block;
  background-clip: content-box, padding-box;
  overflow: visible;
  position: relative;
  z-index: 1;
}
.stgsrend {
  display: flex;
  flex-direction: column;
  position: relative;
  --content-opacity: 1;
  // --axis-space: 1rem;
  // --axis-spaceX: var(--axis-space);
  // --axis-spaceY: var(--axis-space);
  --clr-svg-back: rgba(255, 255, 255, 0.05);
  --stroke-width: 1;
  // --stroke-width: 2.5;
  // --stroke-width: 4;
  // --stroke-width: 3;
  --svg-radius: 4px;
  padding: 0 0 0 0.25rem;
  // overflow: hidden;

  &_title {
    margin-bottom: 0.5rem;
  }
  &_content-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0 1rem 1rem;
    width: 100%;
    // height: 14rem;
    height: 12rem;

    &_no-data {
      padding: 0;
      .stgsrend_content {
        &::after {
          display: none;
        }
      }
    }
  }
  &_content {
    // overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: crosshair;
    background: var(--clr-svg-back);
    border-radius: var(--svg-radius);
  }
  &_axis-zero {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    // width: calc(100% + 1rem);
    width: 100%;
    left: 0rem;
    z-index: 2;
    &_content {
      color: var(--clr-black-4);
      font-size: 0.8rem;
      position: absolute;
      left: -1rem;
    }
    &::after {
      content: '';
      height: 1px;
      width: 100%;
      background: var(--clr-black-4);
      position: absolute;
      left: 0;
      z-index: 2;
    }
  }
}

.chart {
  &_tooltip-line {
    position: absolute;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;

    // &_horizontal {
    //   height: 0;
    //   width: 100%;
    //   border-top: var(--clr-grey-2) dashed 1px;
    //   .chart_tooltip-line_tick {
    //     inset: var(--tick-inset-horizontal);
    //   }
    // }
    &_vertical {
      width: 0;
      height: 100%;
      top: 0 !important;
      border-right: var(--clr-grey-2) dashed 1px;
      .chart_tooltip-line_tick {
        inset: var(--tick-inset-vertical);
      }
    }
    // &_tick {
    //   color: var(--clr-tick);
    //   height: var(--tick-height);
    //   background: var(--clr-tick-back);
    //   position: absolute;
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    // }
  }
}

.trendchart {
  // transform: rotate(180deg);
  &_svg {
    height: 100%;
    width: 100%;
    // height: calc(100% - var(--axis-spaceY));
    // width: calc(100% - var(--axis-spaceX));
    // background: var(--clr-svg-back);
    // border-radius: var(--svg-radius);

    position: absolute;
    right: 0;
    top: 0;
    z-index: 2;
    // width: 100%;
    // top: 0;
    &_content {
      height: 100%;
      width: 100%;
      opacity: var(--content-opacity);
    }

    &_circle {
      stroke-linecap: round;
      stroke-width: 6;
      // stroke-width: 9;
      opacity: 0;
      z-index: 1;
      stroke: var(--clr-score);
      &_active {
        opacity: 1;
        stroke-width: 12;
      }
    }
  }
  // https://medium.com/@cereallarceny/getting-gradients-to-follow-along-svg-paths-in-javascript-45357b60bed7
  &_path {
    z-index: 0;
    position: relative;
    fill: transparent;
    // fill: linear-gradient(90deg, red, blue);
    stroke-width: 2;
    // stroke: var(--clr-primary);
  }
}
</style>
